import React, { useState } from 'react';
import {
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Link,
  Box,
  Container,
  useTheme,
} from '@mui/material';
import { toast } from 'react-toastify';
import {api } from '../helpers/apiRequest';
import { useNavigate } from 'react-router-dom';
import colors from '../theme/Colors';


const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post(`users/login`, { email, password });
      // Save user data to localStorage
      localStorage.setItem('user', JSON.stringify(response.data));
      onLogin(true);
      toast.success('Login Successful');
      // alert('Login Successful');
      navigate('/');
      // Handle login response (e.g., save token, redirect to dashboard)
    } catch (error) {
      onLogin(false);
      toast.error(error.response?.data?.message || 'Login Failed');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <Card
          sx={{
            width: '100%',
            maxWidth: 400,
            boxShadow: 4,
            padding: 2,
          }}
        >
          <CardContent>
            <Typography
              variant="h5"
              gutterBottom
              align="center"
              sx={{ color: colors.primary }}
            >
              Ideal-fleece
            </Typography>
            <Typography variant="body2" align="center" sx={{ mb: 2 }}>
              Please login to your account
            </Typography>
            <Box component="form" onSubmit={handleSubmit} noValidate>
              <TextField
                fullWidth
                label="Email"
                variant="outlined"
                margin="normal"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <TextField
                fullWidth
                label="Password"
                type="password"
                variant="outlined"
                margin="normal"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  mt: 3,
                  mb: 2,
                  backgroundColor: colors.primary,
                }}
              >
                Login
              </Button>
              {/* <Box textAlign="center">
                <Link href="/forgot-password" underline="hover">
                  Forgot Password?
                </Link>
              </Box>
              <Typography textAlign="center" variant="body2" sx={{ mt: 2 }}>
                Don't have an account?{' '}
                <Link href="/signup" underline="hover">
                  Sign Up
                </Link>
              </Typography> */}
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default Login;
